import { PaymentMethod } from 'ha/services/apiV2/types/PaymentMethod';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

export default (makeCall: MakeCall) => (userId: number) =>
  makeCall<PaymentMethod[]>(
    'GET',
    `${APIV2_URL}/user/${userId}/payment-methods`,
  );
